import React from 'react'
import { Formik, Form } from 'formik'
import {
  InputField,
  LoaderButton
} from 'components/molecules'
import PropTypes from 'prop-types'

const propTypes = {
  filterValues      : PropTypes.object.isRequired,
  onClickSubmitForm : PropTypes.func.isRequired,
  onClickReset      : PropTypes.func.isRequired
}

/**
 * Form to filters Customer::Cart::Voucher::Rule data
 * @param {Object} filterValues - current url filter values
 * @param {Function} onClickSubmitForm - function to submit form
 * @param {Function} onClickReset - function to reset for
 */

const BOOLEAN_STATUS = Object.freeze({
  DEFAULT: {
    label : 'Pilih Opsi',
    value : ''
  },
  YES: {
    label : 'Yes',
    value : true
  },
  NO: {
    label : 'No',
    value : false
  }
})

const VoucherRuleFilterForm = ({
  filterValues,
  onClickSubmitForm,
  onClickReset
}) => (
  <Formik
    initialValues={{
      page             : filterValues.page || 1,
      per_page         : filterValues.per_page || 10,
      name             : filterValues.name || '',
      start_from_date  : filterValues.start_from_date || '',
      start_to_date    : filterValues.start_to_date || '',
      expire_from_date : filterValues.expire_from_date || '',
      expire_to_date   : filterValues.expire_to_date || '',
      is_active        : filterValues.is_active || '',
      show_on_checkout : filterValues.show_on_checkout || '',
      voucher_code     : filterValues.voucher_code || ''
    }}
    enableReinitialize={ true }
    onSubmit={ onClickSubmitForm }
  >
    {
      ({ isSubmitting }) => (
        <Form>
          <InputField
            type='input'
            name='name'
            label='Name'
            placeholder="Search by voucher name"
            bsSize={ 'sm' }
          />

          <InputField
            type='input'
            name='voucher_code'
            label='Voucher Code'
            placeholder="Search by voucher code"
            bsSize={ 'sm' }
          />

          <InputField
            type={ 'select' }
            name={ 'is_active' }
            label={ 'Is Active' }
            bsSize={ 'sm' }
          >
            {
              Object.keys(BOOLEAN_STATUS).map((key) => (
                <option
                  key={ `select-table-filter-option-${BOOLEAN_STATUS[key].label}` }
                  value={ BOOLEAN_STATUS[key].value }
                >
                  { BOOLEAN_STATUS[key].label }
                </option>
              ))
            }
          </InputField>

          <InputField
            type={ 'select' }
            name={ 'show_on_checkout' }
            label={ 'Show On Checkout' }
            bsSize={ 'sm' }
          >
            {
              Object.keys(BOOLEAN_STATUS).map((key) => (
                <option
                  key={ `select-table-filter-option-${BOOLEAN_STATUS[key].label}` }
                  value={ BOOLEAN_STATUS[key].value }
                >
                  { BOOLEAN_STATUS[key].label }
                </option>
              ))
            }
          </InputField>

          <LoaderButton
            color='primary'
            className='mt-auto'
            type='submit'
            disabled={ isSubmitting }
            isLoading={ isSubmitting }
            text='Filter'
          />
          <LoaderButton
            color='danger'
            disabled={ isSubmitting }
            isLoading={ isSubmitting }
            text='Reset'
            onClick={ onClickReset }
          />
        </Form>
      )
    }
  </Formik>
)

VoucherRuleFilterForm.propTypes = propTypes

export default VoucherRuleFilterForm
